import { EMRdetailsProps, IEMRUpdatePayloadProps } from "@/api_framework/api_modals/EMRs";
import { useUpdateTempEMRAPI } from "@/app/hooks/api_hooks/emr/useUpdateTempEMRAPI";
import { debounce } from "lodash";
import { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";

interface IGroomingVisitForm {
  not_advised: boolean;
  reason: string;
}

const GroomingVisitComponent = ({ emrDetails, setEmrDetails }: EMRdetailsProps) => {
  const { execute: updateEmrAPI } = useUpdateTempEMRAPI();
  const params = new URLSearchParams(location.search);
  const emr_id = params.get("emr_id");
  const emr_status = params.get("emr_status");

  const formHook = useForm<IGroomingVisitForm>({
    mode: "onChange",
    defaultValues: { not_advised: false, reason: "" },
  });
  const isNotAdvised = formHook.watch("not_advised");
  const reasonValue = formHook.watch("reason");
  const isReasonMissing = isNotAdvised && !reasonValue?.trim();

  const debouncedUpdate = useMemo(
    () =>
      debounce((data: IGroomingVisitForm) => {
        const body: IEMRUpdatePayloadProps = {
          grooming_visit: {
            not_advised: data.not_advised,
            reason: data.reason,
          },
          emr_status: emrDetails?.emr_status ?? emr_status,
        };
        updateEmrAPI(emr_id, body).then(({ status, message }) => {
          if (status && message) setEmrDetails(message);
        });
      }, 500),
    [emr_id, emrDetails?.emr_status, updateEmrAPI, setEmrDetails],
  );

  useEffect(() => {
    if (emrDetails?.grooming_visit) {
      formHook.reset({
        not_advised: Boolean(emrDetails.grooming_visit.not_advised),
        reason: emrDetails.grooming_visit.reason || "",
      });
    }
  }, [emrDetails]);

  useEffect(
    () => () => {
      debouncedUpdate.cancel();
    },
    [debouncedUpdate],
  );

  return (
    <div id="grooming-visit-section" className="w-full bg-white p-2 rounded-[10px] mt-3">
      <h3 className="text-[#656565] text-sm font-medium tracking-tight42 px-2">Grooming</h3>
      <div className="bg-[#F9FAFB] rounded-xl p-3 mt-2">
        <label className="inline-flex items-center gap-2 cursor-pointer select-none">
          <input
            type="checkbox"
            className="h-4 w-4 rounded border-gray-300 text-black cursor-pointer"
            {...formHook.register("not_advised", {
              onChange: (e) => {
                if (!e.target.checked) formHook.setValue("reason", "");
                debouncedUpdate(formHook.getValues());
              },
            })}
          />
          <span className="text-[#000000] text-sm font-medium">Grooming not Advised</span>
        </label>
        <div className="bg-white rounded-xl p-[10px] mt-2">
          <h3 className="text-[#000000] text-sm font-medium tracking-tight42 mb-2">
            Reason{isNotAdvised && <span className="text-red-500"> *</span>}
          </h3>
          <textarea
            rows={2}
            disabled={!isNotAdvised}
            className={`w-full border rounded-xl p-3 text-sm focus:outline-none transition-colors ${
              !isNotAdvised
                ? "bg-[#F9FAFB] text-gray-400 border-[#E2E2E2] cursor-not-allowed placeholder-gray-400"
                : `bg-white text-black placeholder-[#6C727F] ${isReasonMissing ? "border-red-500" : "border-[#E2E2E2]"}`
            }`}
            placeholder="Enter reason"
            {...formHook.register("reason", {
              onChange: () => debouncedUpdate(formHook.getValues()),
            })}
          ></textarea>
          {isReasonMissing && <p className="text-red-500 text-xs mt-1">Reason is required</p>}
        </div>
      </div>
    </div>
  );
};

export default GroomingVisitComponent;
